var CornerType;
(function (CornerType) {
    CornerType[CornerType["nw"] = 0] = "nw";
    CornerType[CornerType["ne"] = 1] = "ne";
    CornerType[CornerType["se"] = 2] = "se";
    CornerType[CornerType["sw"] = 3] = "sw";
})(CornerType || (CornerType = {}));
;
export default CornerType;
//# sourceMappingURL=CornerType.js.map
